"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _authToken, _sessionKey;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Endpoint = exports.RootConnection = exports.Command = exports.RemoteException = exports.ErrorCode = exports.isBrowser = exports.isNode = void 0;
const SimpleBoss_1 = require("./SimpleBoss");
const unicrypto_1 = require("unicrypto");
exports.isNode = typeof process !== 'undefined'
    && process.versions != null
    && process.versions.node != null;
exports.isBrowser = !exports.isNode;
class ErrorCode extends Error {
    constructor(code, text) {
        super(text ? `${code}: ${text}` : `error executing API command: ${code}`);
        this.code = code;
        this.text = text;
    }
}
exports.ErrorCode = ErrorCode;
class RemoteException extends ErrorCode {
    constructor(code, text) {
        super(code, text);
    }
}
exports.RemoteException = RemoteException;
const portableFetch = exports.isNode ? require('node-fetch') : window.fetch;
/**
 * Basic Parsec command and result utilities.
 */
class Command {
    /**
     * Pack parsec command using method name and key-value arguments.
     * @param method name
     * @param args method arguments
     * @return binary parsec command block
     */
    static pack(method, args = {}) {
        return SimpleBoss_1.bossDump({ cmd: method, args: args });
    }
    /**
     * Unpack remote binary command result (parsec) and extract the returned value (or
     * empty object {}) or throw
     * {@link RemoteException} if the execution result is an error.
     *
     * @param packed
     * @throws RemoteException
     */
    static unpack(packed) {
        var _a;
        const data = SimpleBoss_1.bossLoad(packed);
        if (data.error)
            throw new RemoteException(data.error.code, data.error.text);
        return (_a = data.result) !== null && _a !== void 0 ? _a : {};
    }
}
exports.Command = Command;
/**
 * Level 0 parsec connection, used to execute authentication and registration commands,
 * which in turn should provide credentials to connect a secure {@link Endpoint}.
 * Usually, this type of connection is used to access API root, what explains the name.
 */
class RootConnection {
    /**
     * Construct anonymous parsec connection gate using a given root URL, which is
     * typical "https://acme.com/api/p1" or "https://parsec.acme.com/p1" - p1 means it
     * accepts and executes level 1 commands that come without extra authentication and
     * encryption. See {@link Endpoint} and {@link "ParsecSession"} for Session class that
     * consumes and implements PConnection.
     *
     * @param rootUri URI to connect to.
     */
    constructor(rootUri) {
        if (!rootUri)
            throw "root URI is undefined";
        this.rootUri = rootUri;
    }
    async call(method, params = {}) {
        if (RootConnection.traceCommands)
            console.info(`>> ${method}:`, params);
        const packedResult = await this.request(Command.pack(method, params));
        const result = Command.unpack(packedResult);
        if (RootConnection.traceCommands)
            console.info(`<< ${method}:`, result);
        return result;
    }
    request(packed) {
        // nodejs roaches
        const fd = exports.isBrowser ? FormData : require('form-data');
        const formData = new fd();
        // noinspection TypeScriptUnresolvedVariable
        formData.append("cmd", 
        // nodejs has more roaches:
        exports.isBrowser ? new Blob([packed], { type: "application/octet-stream" }) : Buffer.from(packed), new Date().toJSON() + ".bin");
        return portableFetch(this.rootUri, {
            method: "POST",
            body: formData
        }).then(function (resp) {
            return resp.blob();
        }).then(function (blob) {
            // return new Response(blob).arrayBuffer()
            // return fileReader.readAsArrayBuffer(blob)
            return blob.arrayBuffer();
        }).then(function (ab) {
            return new Uint8Array(ab);
        });
    }
}
exports.RootConnection = RootConnection;
RootConnection.traceCommands = false;
/**
 * The adapter for encrypted/authenticated commands. Basically endpoint is created during
 * registration/login or host authentication procedures. There could be nested endpoints
 * too. Basically, Endpoint is just a encrypted and authenticated version of
 * {@link RootConnection}.
 */
class Endpoint {
    constructor(connection, params) {
        _authToken.set(this, void 0);
        _sessionKey.set(this, void 0);
        __classPrivateFieldSet(this, _authToken, params.authToken);
        __classPrivateFieldSet(this, _sessionKey, new unicrypto_1.SymmetricKey({ keyBytes: params.sessionKey }));
        this.connection = connection;
    }
    serialize() {
        return { sessionKey: __classPrivateFieldGet(this, _sessionKey).pack(), authToken: __classPrivateFieldGet(this, _authToken) };
    }
    async call(method, params = {}) {
        const answer = await this.connection.call("cmd", {
            authToken: __classPrivateFieldGet(this, _authToken),
            params: await __classPrivateFieldGet(this, _sessionKey).etaEncrypt(Command.pack(method, params))
        });
        return Command.unpack(await __classPrivateFieldGet(this, _sessionKey).etaDecrypt(answer.result));
    }
}
exports.Endpoint = Endpoint;
_authToken = new WeakMap(), _sessionKey = new WeakMap();
//# sourceMappingURL=Parsec.js.map